import { apiClient } from '../client'
import type { SslDetail, SslResponse } from '../../app/modules/types/ssl'
import type { OptionsType } from '../../app/modules/types/filters'
/**
 * SSL API endpoints
 */
export const sslApi = {
  /**
   * Get SSL certificates list
   */
  getList: async (params?: string): Promise<SslResponse> => {
    const url = params ? `/ssl/?${params}` : '/ssl/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get SSL certificate by ID
   */
  getById: async (sslId: string): Promise<SslDetail> => {
    const { data } = await apiClient.get(`/ssl/${sslId}/`)
    return data
  },

  /**
   * Get SSL statistics
   */
  getStats: async (): Promise<any> => {
    const { data } = await apiClient.get('/ssl/stats/')
    return data
  },

  /**
   * Get SSL filter options
   */
  getFilterOptions: async (): Promise<OptionsType> => {
    const { data } = await apiClient.get('/ssl/filter/')
    return data
  },
}
